import { RichText } from 'components_new/molecules/RichTextEditor/types'
import { IPermission } from './GlobalPermission'
import { TDashboard } from './GlobalDashboard'
import { TTaskResponse } from 'redux/api/Tasks'

/* Enums */
export enum Category {
  ENERGY = 'ENERGY',
  REAL_ESTATE_PORTFOLIO = 'REAL_ESTATE_PORTFOLIO',
  RENTAL = 'RENTAL',
  TECHNICAL_MANAGEMENT = 'TECHNICAL_MANAGEMENT',
  ECONOMY = 'ECONOMY',
  HOMEPAL = 'HOMEPAL'
}

export enum DashboardOwnership {
  OWNED_BY_ME = 'OWNED_BY_ME',
  SHARED_WITH_ME = 'SHARED_WITH_ME',
  NO_ACCESS = 'NO_ACCESS'
}

export enum DashboardStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  OPEN = 'OPEN',
  COMPLETED = 'COMPLETED'
}

export enum WhoCanView {
  ONLY_ADDED_USERS = 'ONLY_ADDED_USERS',
  ORGANIZATION = 'ORGANIZATION'
}

/* Types & Interfaces */
export interface IDashboardGroupShareSettings {
  all_company_groups_has_access: boolean
  who_can_view: WhoCanView
  permissions: IPermission[]
}

export type TResourceFilter = {
  attribute_id: string
  index: number
}

export type TDashboardGroup = {
  category: {
    selected: Category | null
    options: Category[]
  }
  created_at: string
  dashboard_filters: TResourceFilter[]
  dashboards: TDashboard[]
  description: RichText | null
  favorite: boolean
  firstDashboardId: string | null
  folder_id: string | null
  id: string
  latest_visit: Date | null
  owner: string
  ownership: DashboardOwnership
  share_settings: IDashboardGroupShareSettings
  status: DashboardStatus
  tasks: TTaskResponse[]
  thumbnail: string | null
  title: string
  updated_at: string
}

// Activity
export type TDashboardGroupActivityUser = {
  first_name: string
  last_name: string
  email: string
}

export type TDashboardGroupActivityView = {
  date: string
  dashboard_id: string
  user_id: string
}

export type TDashboardGroupActivity = {
  created_at: string
  views: TDashboardGroupActivityView[]
  accounts: {
    [id: string]: TDashboardGroupActivityUser
  }
  dashboards: {
    [id: string]: { title: string }
  }
  dashboard_groups: {
    // org. dashboard for benchmark
    [id: string]: { id: string; title: string; total_views: number }
  }
}

export type TDashboardGroupResponse = {
  id: string
  folder_id: string | null
  title: string
  description: RichText | null
  ownership: DashboardOwnership
  created_at: string
  updated_at: string
  thumbnail: string | null
  dashboards: TDashboard[]
  dashboard_filters: TResourceFilter[]
  share_settings: IDashboardGroupShareSettings
  category: {
    selected: Category | null
    options: Category[]
  }
  status: DashboardStatus
  owner: string
  latest_visit: Date | null
}
